<script>
    import {TextInput} from "m7-library";
    import {t} from "$utils/lang.js";
    import AddressAutocomplete from "$component/AddressAutocomplete.svelte";

    let {
        address = $bindable(),
        errors = {},
        label = '',
    } = $props();

    // Auto-open if data is already present (e.g. loaded from server)
    let showCompany = $state(false);
    let showAddInfo = $state(false);

    $effect(() => {
        if (address.company || address.ustid) showCompany = true;
        if (address.addInfo) showAddInfo = true;
    });

    function toggleCompany() {
        showCompany = !showCompany;
        if (!showCompany) {
            address.company = '';
            address.ustid = '';
        }
    }

    function toggleAddInfo() {
        showAddInfo = !showAddInfo;
        if (!showAddInfo) {
            address.addInfo = '';
        }
    }
</script>

<div class="flex flex-col gap-3">
    {#if label}
        <div class="font-bold text-sm text-cyprus">{label}</div>
    {/if}

    <AddressAutocomplete {address} {errors}/>

    <div class="flex flex-col gap-2">
        <button
            onclick={toggleCompany}
            class="text-left text-elm cursor-pointer text-sm"
        >
            {#if showCompany}{t("- Firmendaten entfernen")}{:else}{t("+ Firmendaten hinzufügen")}{/if}
        </button>
        {#if showCompany}
            <div class="flex flex-col gap-3">
                <TextInput
                    name="company"
                    bind:value={address.company}
                    label={t("Firma")}
                    placeholder={t("Musterfirma GmbH")}
                    autocomplete="organization"
                />
                <TextInput
                    name="ustid"
                    bind:value={address.ustid}
                    label={t("USt-IdNr.")}
                    placeholder={t("DE123456789")}
                />
            </div>
        {/if}
    </div>

    <div class="flex flex-col gap-2">
        <button
            onclick={toggleAddInfo}
            data-checkout-action="toggle-addinfo"
            class="text-left text-elm cursor-pointer text-sm"
        >
            {#if showAddInfo}{t("- Adresszusatz entfernen")}{:else}{t("+ Adresszusatz hinzufügen")}{/if}
        </button>
        {#if showAddInfo}
            <TextInput
                name="addInfo"
                bind:value={address.addInfo}
                label={t("Adresszusatz")}
                placeholder={t("2. Stock, Hinterhaus")}
            />
        {/if}
    </div>
</div>
